import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import axios from 'axios'

const app = createApp(App)

app.use(router)

app.mount("#app")

app.config.globalProperties.$http = axios

router.beforeEach((to) => {
    const route = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    document.title = route.meta.title
})